"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nextStore, state) {
  // #! state = payload, 这是特殊处理
  if (nextStore.asMutable) {
    nextStore = nextStore.merge(state);
  } else {
    Object.keys(state).forEach(function (name) {
      // 严格判断存在属性
      if (Object.prototype.hasOwnProperty.call(nextStore, name)) {
        nextStore[name] = state[name];
      }
    });
  }
  return nextStore;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/seed/reducerImmediate.js
// module id = 86
// module chunks = 0